// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__10ibu","amount":"Amount_amount__BDmio","tip":"Amount_tip__335dW","tipHeader":"Amount_tipHeader__3ZxUp","tipsWrap":"Amount_tipsWrap__1ifEI"};